var map = {
	"./beach-1853939_1920.jpg": "62af",
	"./legs-434918_1920.jpg": "7774",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./road-2371503_1920.jpg": "80a4",
	"./vue.config": "8846",
	"./vue.config.js": "8846"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";